const baseInfo = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  // showProgressBar: 'top',
  // progressBarType: 'questions',
  goNextPageAutomatic: false,
  // firstPageIsStarted: true,
  showPrevButton: true,
  showNavigationButtons: true,
  pageNextText: 'Siguiente',
  pagePrevText: 'Atrás',
  showQuestionNumbers: 'off',
  requiredText: `*`,
  pages: [
    {
      name: 'DEMOG_PAGE_01',
      // title: 'Bienvenido',
      elements: [
        {
          type: 'html',
          name: 'HTML_01',
          html: `
          <legend>
            <div class="QuestionText BorderColor">
              <div>
                <span style="font-size:16px;">
                  <span style="font-family:arial,helvetica,sans-serif;">
                    <h3>Bienvenido a Vocation Start</h3>
                    <br>
                    Este Test ha sido desarrollado especialmente para estudiantes de octavo básico y primeros años de enseñanza media, que están enfrentando el proceso de transición a educación media y sus responsabilidades.
                    <br><br>
                    El paso a educación media puede implicar una serie de cambios, como cambios de salas, horarios, profesores o amigos, así como también cambios en las evaluaciones, pruebas y trabajos que deberás realizar. También es una etapa de nuevos desafíos académicos, donde tus notas comienzan a tener mayor importancia (ya que influirán en tus posibilidades de postulación a distintas carreras en el futuro). Además, es el momento en que comienzas a tomar las primeras decisiones en relación a tu futuro al salir del colegio.
                    <br><br>
                    Todos estos cambios y nuevos desafíos a veces pueden resultar abrumadores, por eso, el objetivo del Test Vocation Start es entregarte información sobre tus principales fortalezas y aspectos que puedes mejorar para enfrentar de forma exitosa esta nueva etapa.
                    <br><br>
                    Puedes responder este cuestionario desde el lugar que más te acomode, pero te recomendamos responderlo desde un computador, para que te sea más simple, en un espacio cómodo donde te puedas concentrar.
                    <br><br>
                    El cuestionario tiene 5 secciones. Dentro de cada sección podrás avanzar y retroceder para cambiar tus respuestas, pero una vez que termines la sección y las respuestas se guarden, no podrás volver a atrás.
                    <br><br>
                    El test total tarda aproximadamente <strong>30 minutos</strong>, por lo que te recomendamos realizarlo con tiempo.
                    <br><br>
                    Haz click en <em>Siguiente</em> para continuar.
                  </span>
                </span>
              </div>
              <br>
            </div>
          </legend>
          `
        }
      ]
    },
    {
      name: 'DEMOG_PAGE_02',
      title: 'Bienvenido',
      elements: [
        {
          type: 'html',
          name: 'HTML_01',
          html: `
          <legend>
            <div class="QuestionText BorderColor">
              <span style="font-size:16px;">
                Por favor, completa los datos requeridos a continuación:
              </span>
              <br>
            </div>
          </legend>
          `
        },
        // {
        //   type: 'text',
        //   inputType: 'date',
        //   name: 'BIRTH',
        //   title: 'Fecha de nacimiento',
        //   isRequired: true,
        //   min: '1950-01-05',
        //   max: '2020-01-01'
        // },
        {
          type: 'text',
          name: 'BIRTH',
          title: 'Fecha de nacimiento (DD/MM/AAAA)',
          isRequired: true,
          inputType: 'masked',
          correctAnswer: '99/99/9999'
        },
        {
          type: 'radiogroup',
          name: 'SEX',
          title: 'Género',
          visibleIf: '{gen} empty',
          isRequired: true,
          choices: [
            {
              value: '1',
              text: 'Masculino'
            },
            {
              value: '2',
              text: 'Femenino'
            },
            {
              value: '3',
              text: 'Prefiero no decir'
            }
          ]
        }
      ]
    }
  ]
};

export default baseInfo;
